error_manager = function(data) {
    //console.log(data);
    if(data.errors) {
        return error_array(data.errors);
    }

    if(data.success && data.msgs) {
        return success_array(data.msgs);
    }

    if(data.responseText) {
        return data.responseText;
    }

    return data;
};

/*
error_create = function (error) {
    var msg  = '<div class="alert alert-danger">';
        msg += '    <h4 class="alert-heading">Erro</h4>';
        msg += '    <ul>';
        msg += '        <li>Ocorreu um erro inesperado. Tente novamente.</li>';
        msg += '    </ul>';
        msg += '    <h6 class="alert-heading">Código: ' + error.status + '</h6>';
        msg += '    <h6 class="alert-heading">Mensagem: ' + error.statusText + '</h6>';
        msg += '</div>';
    return msg
};
*/

error_array = function (errors) {
    var msg  = '';
    //msg += '<div class="card">';
    msg += '    <div class="alert alert-danger alert-card">';

    //
    if(errors.length == 1) {
        msg += '        <h4 class="alert-heading">Ops...!</h4>';
    } else {
        msg += '        <h4 class="alert-heading">Ops...!</h4>';
    }

    msg += '        <ul>';
                        $.each(errors, function(key, value){
                            msg += '<li>' + value + '</li>';
                        });
    msg += '        </ul>';
    msg += '    </div>';
    //msg += '</div>';
    return msg
};

success_array = function (errors) {
    var msg  = '';
    //msg += '<div class="card">';
    msg += '    <div class="alert alert-success alert-card">';
    //msg += '        <h4 class="alert-heading"><span class="fa fa-check"></span></h4>';

    if(errors.length == 1) {
        msg += errors[0];
    } else {
        msg += '        <ul>';
                            $.each(errors, function(key, value){
                                msg += '<li>' + value + '</li>';
                            });
        msg += '        </ul>';
    }


    msg += '    </div>';
    //msg += '</div>';
    return msg
};